import moment from 'moment'
const TAB_VALUE = {
  all: 0,
  active: 1,
  pending: 2,
  synError: 3,
}

export const tabList = (t, totals) => {
  const { all } = totals
  return [
    {
      label: `${t('common.all')} (${all})`,
      value: TAB_VALUE.all,
    },
  ]
}

export const dateFilterDefault = (data) => {
  const currentDate = data ? moment(data) : moment()
  const date = moment(currentDate).date()

  if (date > 20) {
    return {
      start: currentDate,
      end: moment(currentDate).add(1, 'months').subtract(1, 'days'),
    }
  }
  return {
    start: moment(currentDate).subtract(1, 'months'),
    end: moment(currentDate).subtract(1, 'days'),
  }
}

// export const SUB_COLUMN_KEYS = ['guest', '45', '29', '16', '7']

export const enumerateDaysBetweenDates = function (
  startDate,
  endDate,
  vehicles,
) {
  const dates = []

  const currDate = moment(startDate).startOf('day')
  const lastDate = moment(endDate).startOf('day')
  do {
    const weekday = currDate.weekday()
    const key = currDate.format('YYYY_MM_DD')

    dates.push({
      key,
      title: currDate.format('D MMM'),
      isWeekend: weekday === 0 || weekday === 6 ? true : false,
      subKeys: [
        {
          key: `${key}_guest`,
          title: `reportAll.guest`,
        },
        ...vehicles.map((vehicle) => ({
          key: `${key}_${vehicle.code}`,
          title: vehicle.name,
        })),
      ],
    })
  } while (currDate.add(1, 'days').diff(lastDate) <= 0)

  return dates
}

export const CAT_SHIFT_LTF_CODE = ['1', '2', '3', 'D']

export const TYPE_REGISTER = [
  {
    label: 'reportAll.bus',
    value: '0',
  },
  {
    label: 'reportAll.typeRegisterAll',
    value: '1',
  },
]